/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const SquareStop = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" }]
];

export { SquareStop as default };
//# sourceMappingURL=square-stop.js.map
